import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useToast } from "@/view/components/ui/use-toast";
import { transactionsService } from "@/app/services/transactionService";

const getAvailableCreditSchema = z.object({
  cpf: z
    .string()
    .length(14, "O cpf deve seguir o seguinte formato xxx.xxx.xxx-xx")
    .refine((f) => {
      const regex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
      return regex.test(f);
    }, "O cpf deve seguir o seguinte formato xxx.xxx.xxx-xx")
    .transform((f) => f.replace(/\D/g, "")),
});
type getAvailableCreditFormData = z.infer<typeof getAvailableCreditSchema>;
export default function useNewTransferModal() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const getAvailableCreditForm = useForm<getAvailableCreditFormData>({
    resolver: zodResolver(getAvailableCreditSchema),
  });

  const { handleSubmit } = getAvailableCreditForm;
  const submitModal = handleSubmit(
    async ({ cpf }: getAvailableCreditFormData) => {
      try {
        setIsLoading(true);
        const { blocked } = await transactionsService.checkCpf(cpf);
        if (blocked) {
          toast({
            variant: "destructive",
            title: "Este CPF já possui uma transação neste mês",
          });
          return;
        }
        navigate(cpf);
      } catch {
        toast({
          variant: "destructive",
          title: "Erro ao verificar CPF, tente novamente",
        });
      } finally {
        setIsLoading(false);
      }
    },
  );

  return { form: getAvailableCreditForm, submitModal, isLoading };
}
